const inputViewNew = {
  placeholder: 'Write here...'
};

export default inputViewNew;
